"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button_1 = require("decentraland-ui/dist/components/Button/Button");
const ModalNavigation_1 = require("decentraland-ui/dist/components/ModalNavigation/ModalNavigation");
const utils_1 = require("../../modules/translation/utils");
const Modal_1 = __importDefault(require("../../containers/Modal"));
const UnsupportedNetworkModal = ({ chainName, expectedChainName, isSwitchingNetwork, onSwitchNetwork }) => {
    return (react_1.default.createElement(Modal_1.default, { open: true, size: "tiny" },
        react_1.default.createElement(ModalNavigation_1.ModalNavigation, { title: react_1.default.createElement(utils_1.T, { id: "@dapps.navbar.wrong_network.header" }) }),
        react_1.default.createElement(Modal_1.default.Content, null, !chainName ? (react_1.default.createElement(utils_1.T, { id: "@dapps.navbar.wrong_network.message_unknown_network", values: {
                expectedChainName: react_1.default.createElement("b", null, expectedChainName)
            } })) : (react_1.default.createElement(utils_1.T, { id: "@dapps.navbar.wrong_network.message", values: {
                currentChainName: react_1.default.createElement("b", null, chainName),
                expectedChainName: react_1.default.createElement("b", null, expectedChainName)
            } }))),
        react_1.default.createElement(Modal_1.default.Actions, null,
            react_1.default.createElement(Button_1.Button, { primary: true, disabled: isSwitchingNetwork, loading: isSwitchingNetwork, onClick: onSwitchNetwork },
                react_1.default.createElement(utils_1.T, { id: "@dapps.navbar.wrong_network.switch_button", values: {
                        chainName: react_1.default.createElement("b", null, expectedChainName)
                    } })))));
};
exports.default = UnsupportedNetworkModal;
//# sourceMappingURL=UnsupportedNetworkModal.js.map